<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center loading-dialog3">
      <p class="text-gray-600 font-bold animate-pulse" style="font-size: 30px">Downloading...</p>
    </div>
    <PageHeader title="ダウンロード">
      <template #page-header-content>
        <div class="pl-4 flex justify-between">
          <h1 class="text-lg font-bold text-white flex items-center">
            <Icon iconName="" class="w-7 h-7 mr-2" />
            <span class="mt-0">設備点検 ダウンロード</span>
          </h1>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-28 w-full bottom-4 -mt-2">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <!-- Google共有ドライブにアップ -->
          <div class="mt-20 py-5 px-10 rounded bg-blue-50 w-fit mx-auto">
            <div class="flex justify-center">
              <div>
                <div class="text-xs text-gray-700 mb-0.5 font-bold">完了日</div>
                <input
                  type="date"
                  class="py-1"
                  v-model="googleDate"
                  :max="max"
                  @change="getSiteList()"
                >
              </div>
              <div class="mx-3 mt-auto">に完了した</div>

              <WmsSuggestInput
                name="site"
                caption="物件（指定がある場合）"
                displayField="siteName"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="siteList"
                class=""
                v-model="siteName"
              />
              <div class="mx-3 mt-auto">の報告書を</div>
            </div>

            <div class="text-center mt-5"><PrimaryButton text="Google共有ドライブへアップ" :disabled="!googleDate||!admin" :class="!admin?'bg-gray-400':''" @click="roundReportToGoogle" :buttonContents="'要'" /></div>

            <div class="text-center mt-5 text-sm">管理者権限のみGoogle共有ドライブへアップ可能</div>
            <div class="text-center mt-5 text-sm text-red-700">※毎晩自動でアップしています。エラー等でアップできなかった場合のみご利用ください。</div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    Icon,
    WmsSuggestInput,
    PrimaryButton,
    PageHeader
  },

  data() {
    return {
      loading: false,
      type: 4,
      typeName: '設備点検',
      // 物件一覧
      siteList: [
        { siteName: '' }
      ],
      // 物件
      siteName: '',
      // Google共有ドライブへアップする完了日
      googleDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
      // 昨日以前の日付のみ
      max: moment().add(-1, 'days').format('YYYY-MM-DD'),
      // 管理者権限あり
      admin: false
    }
  },

  created() {
    let auth = this.$store.getters.auth
    if (auth && auth.adminAuth) {
      this.admin = true
      this.getSiteList()
    }
  },

  methods: {
    /**
     * 物件リストを取得
     */
    async getSiteList() {
      if (this.admin) {  
        const cR = await backend.searchData('patrolResult/getGroupingSiteByTerm', { date: this.googleDate, type: this.type })
        if (cR.data && cR.data.data.length) {
          this.siteList = cR.data.data
        } else {
          this.siteList = [{ siteName: '' }]
        }
      }
    },

    /**
     * 巡回清掃報告書Google共有ドライブへアップロード
     */
    async roundReportToGoogle() {
      if (!this.admin) {
        alert('管理者のみ可能です。')
        return
      }
      await backend.postData('cron/reportToGoogle', { from: 'rp', date: this.googleDate, site: this.siteName, type: 4 })
      dialogs.showInfoDialog('結果はGoogle共有ドライブ内の「結果ログ」参照', 'アップには時間がかかります。時間をおいて、Google共有ドライブの対象フォルダを確認するか「結果ログ」をご確認ください。\r\nこの画面は閉じて大丈夫です。')
    }

  },
}
</script>
<style scoped>
.main {
  width: 100%;
}

.w-800px {
  width: 800px;
}

.w-750 {
  width: 750px;
}

#filterDate {
  width: 100% !important;
}

#filterDate >>> div {
  color: rgb(70, 70, 70) !important;
}

#filterDate >>> input[type=text] {
  background: white !important;
}
</style>